// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AddToCartJewelleryExistingCustomerDocument = gql`
    mutation addToCartJewelleryExistingCustomer($input: DesignStudioJewelleryInput!) {
  createDesignStudioProductAndAddToCartJewelleryExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useAddToCartJewelleryExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.AddToCartJewelleryExistingCustomerMutation, SchemaTypes.AddToCartJewelleryExistingCustomerMutationVariables>(AddToCartJewelleryExistingCustomerDocument);
};